// TODO Colors are here
export const CLASSIC_TYPO = 'Effra, Roboto';
export const MEDIUM_TYPO = 'Effra Medium, Roboto';
export const BOLD_TYPO = 'Effra Bold, Roboto';

export const MEDIUM_IMPORTANT_TYPO = 'Effra Medium, Roboto !important';
export const CLASSIC_IMPORTANT_TYPO = 'Effra, Roboto !important';
export const ARRAY_TYPO = ['Effra', 'Roboto', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'];
